<!--
 * @Author: 仙道
 * @Date: 2022-04-23 17:33:49
 * @LastEditTime: 2022-04-26 20:52:49
 * @email: hao.li08@weimob.com
 * @Description: 设备参数
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/tabs/AccountParams.vue
-->

<template>
  <div>
    <a-table :columns="tableColumns" :dataSource="propsData" :pagination="false">
      <template slot="status" slot-scope="status">
        <a-badge :status="status | statusTypeFilter" :text="status | statusFilter" />
      </template>
    </a-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AccountParams',
    props: {
      propsData: {
        type: Array,
        default: () => []
      }
    },
    components: {

    },
    // 定义属性
    data () {
      return {
        tableColumns: [
          {
            title: '参数名称',
            dataIndex: 'type',
            key: 'type'
          },
          {
            title: '说明',
            dataIndex: 'type',
            key: 'type'
          }, {
            title: '编码',
            dataIndex: 'type',
            key: 'type'
          }, {
            title: '参数值',
            dataIndex: 'type',
            key: 'type'
          }
        ]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>


</style>
